import { render } from "./roomTransfer.vue?vue&type=template&id=39ebbf14"
import script from "./roomTransfer.vue?vue&type=script&lang=js"
export * from "./roomTransfer.vue?vue&type=script&lang=js"

import "./roomTransfer.vue?vue&type=style&index=0&id=39ebbf14&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__